import { firebaseConfig } from "@/firebase/config";
import placeholderAvatar from "@/assets/placeholder-avatar.png";

// DEUX NOTIONS DISTINCTES (décision CTO du 25/09/2026), jamais sous le même
// libellé à l'écran :
//  - la RARETÉ DU JETON (`animal.rareness` : CR / EN / VU) est une notion de
//    JEU, fixée par le numéro de design du jeton physique (1-16 et 51 : CR,
//    17-30 : EN, 31-50 : VU). Libellé : « Rareté du jeton » ;
//  - le STATUT DE CONSERVATION (UICN) est un fait réel et éducatif. Il vit
//    dans `animal.statutUicn` quand il est renseigné. Libellé : « Statut de
//    conservation ». Tant que le champ n'existe pas, on ne l'affiche PAS : la
//    rareté du jeton n'est pas un statut UICN (elle diffère pour au moins 4
//    animaux, cf. JETONS_PHYSIQUE/mise_en_paquets.md).
export const UICN_LABEL = {
  EX: "Éteint",
  EW: "Éteint à l'état sauvage",
  CR: "En danger critique",
  EN: "En danger",
  VU: "Vulnérable",
  NT: "Quasi menacé",
  LC: "Préoccupation mineure",
  DD: "Données insuffisantes",
};

export const RARENESS_LABEL = {
  VU: "Commun",
  EN: "Occasionnel",
  CR: "Rare",
};

export const LIBELLE_RARETE = "Rareté du jeton";
export const LIBELLE_CONSERVATION = "Statut de conservation";

export const UICN_COLOR = {
  VU: "#d69f1d",
  EN: "#f37a0f",
  CR: "#f60503",
};

export const ANIMAX_STRENGTH = {
  CR: 3,
  EN: 2,
  VU: 1,
};

export const MODULES_COLOR = {
  collection: "gold",
  habitats: "red",
  profil: "purple",
};

export const initPlayer = () => {
  return {
    animals: {},
    habitats: {},
  };
};

export const formatDate = (date) => {
  if (!date) {
    return "";
  }
  const addLeadingZero = (number) => {
    return number < 10 ? `0${number}` : number;
  };
  return `${addLeadingZero(date.getDate())}/${addLeadingZero(
    date.getMonth() + 1
  )}/${date.getFullYear()}`;
};

export const buildImgUrl = (storagePath) => {
  const bucketPath = firebaseConfig.storageBucket;
  const host =
    import.meta.env.VITE_USE_EMULATORS === "true"
      ? "http://localhost:9199"
      : "https://firebasestorage.googleapis.com";
  return `${host}/v0/b/${bucketPath}/o/${encodeURIComponent(storagePath)}?alt=media`;
};

export const numberFormatter = (value) => {
  return value < 10 ? `0${value}` : value;
};

export const buildAvatarUrl = (id) => {
  // placeholderAvatar est importé → Vite le bundle avec une URL hashée valide
  // en prod (l'ancien chemin "/src/assets/..." n'existait qu'en dev → 404).
  if (!id) {
    return placeholderAvatar;
  } else {
    return buildImgUrl(`Avatars/${id}.png`);
  }
};
